import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'
import Logo from '../../images/Logo.png';
import { Avatar, Tooltip, Badge } from 'antd';

class Menu extends Component {

  
    render(){
      
        return(
          <header className="navbar navbar-inverse navbar-fixed-top bs-docs-nav" role="banner">           
  <div className="container">
    <div className="navbar-header">
      <button className="navbar-toggle" type="button" data-toggle="collapse" data-target=".bs-navbar-collapse">
        <span className="sr-only">Toggle navigation</span>
        <span className="icon-bar"></span>
        <span className="icon-bar"></span>
        <span className="icon-bar"></span>
      </button>
      <NavLink to="/clientes" className="navbar-brand">
        <img src={Logo} alt="Logo" style={{maxHeight: '32px', marginTop:'-6px'}}/>
        </NavLink>
        
      {/* <a href="./" className="navbar-brand">Direkton TI</a> */}
    </div>
    <nav className="collapse navbar-collapse bs-navbar-collapse" role="navigation">
      <ul className="nav navbar-nav">
        <li><NavLink to="/clientes" >Clientes</NavLink></li>
      </ul>
      <ul className="nav navbar-nav">
        <li><NavLink to="/contingencias" >Contingências</NavLink></li>
      </ul>
      <ul className="nav navbar-nav">
        <li><NavLink to="/contadores" >Contadores</NavLink></li>
      </ul>
      <ul className="nav navbar-nav">
        <li><NavLink to="/logs" >Logs</NavLink></li>
      </ul>

    <ul className="nav navbar-nav navbar-right" > 
 
        <li>
            <a className="dropdown-toggle" data-toggle="dropdown" title="Utilitários" href="#"><span className="glyphicon glyphicon-align-justify hidden-xs"><span className="caret" ></span></span><span className="visible-xs">Utilitários<span className="caret"></span></span></a>
            <ul className="dropdown-menu dropdown-menu-right">
                <li><Link to="/logout">Sair</Link></li>                
            </ul>
        </li>                
    </ul>

    </nav>
  </div>
</header>
        )
    }
}

const mapStateToProps = (state) => {
  return { auth: state.auth, dados: state.dados  };
};

export default connect(mapStateToProps, { })(Menu);
